export default {
    LINK_BUSINESSWEEK: "linkBusinessweek",
    FILE_DOWNLOAD: "fileDownload",
    UPDATE_SUBSCRIPTION: "updateSubscription",
    SINGLE_PAGE_MODULE_LEVEL: "singlePageModuleLevel",
    RESEND_CONFIRMATION_EMAIL: "resendConfirmationEmail",
    PASSWORD: "password",
    EMAIL: "email",
    REGION: "region",
    PROFESSION: "profession",
    DEACTIVATE_ACCOUNT: "deactivateAccount",
    INVOICES: "invoices",
    UPDATE_PAYMENT: "updatePayment",
    FORGOT_PASSWORD: "forgotPassword",
    CANCEL_NOTICE_UNCHECKED: "cancelNoticeCheck"
};
